<template>
<div v-if="user" class="admin-user-summary sip-view-summary">
    <div class="sip-view-summary__hero">
        <div class="sip-view-summary__avatar">
            <img :src="getAvatar(user)" alt="">
        </div>
        <div class="sip-view-summary__info">
            <h5 class="sip-view-summary__name">{{user.profile.first_name+' '+user.profile.last_name}}</h5>
            <span class="sip-view-summary__email">{{user.email}}</span>
            <div class="sip-view-summary__badges">
                <span v-if="user.profile.gender" class="admin-status-badge admin-status-badge--info">{{ user.profile.gender }}</span>
                <span v-for="status in getUserStatus(user)" :key="status.label" :class="['admin-status-badge', 'admin-status-badge--' + status.color]">{{status.label}}</span>
            </div>
        </div>
    </div>
    <div class="sip-view-summary__social" v-if="hasSocial">
        <ul class="sip-view-summary__social-list">
            <li v-if="user.profile.facebook_profile"><a :href="user.profile.facebook_profile" :aria-label="'Facebook'"><admin-icon name="globe"></admin-icon></a></li>
            <li v-if="user.profile.twitter_profile"><a :href="user.profile.twitter_profile" :aria-label="'Twitter'"><admin-icon name="globe"></admin-icon></a></li>
            <li v-if="user.profile.linkedin_profile"><a :href="user.profile.linkedin_profile" :aria-label="'LinkedIn'"><admin-icon name="globe"></admin-icon></a></li>
            <li v-if="user.profile.google_plus_profile"><a :href="user.profile.google_plus_profile" :aria-label="'Google'"><admin-icon name="globe"></admin-icon></a></li>
        </ul>
    </div>
    <div class="sip-view-summary__actions" v-if="user.id != getAuthUser('id')">
        <button type="button" class="btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--outline" v-if="user.status == 'activated'" @click="updateStatus('banned')"><i class="fas fa-ban"></i> {{ trans('user.user_action_ban') }}</button>
        <button type="button" class="btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--solid" v-if="user.status == 'disapproved'" @click="updateStatus('activated')"><i class="fas fa-check"></i> {{ trans('user.user_action_approve') }}</button>
        <button type="button" class="btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--solid" v-if="user.status == 'pending_activation' || user.status == 'pending_approval'" @click="updateStatus('activated')"><i class="fas fa-user-plus"></i> {{ trans('user.user_action_approve') }}</button>
        <button type="button" class="btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--outline" v-if="user.status == 'pending_activation' || user.status == 'pending_approval'" @click="updateStatus('disapproved')"><i class="fas fa-user-times"></i> {{ trans('user.user_action_disapprove') }}</button>
        <button type="button" class="btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--solid" v-if="user.status == 'banned'" @click="updateStatus('activated')"><i class="fas fa-check"></i> {{ trans('user.user_action_activate') }}</button>
    </div>
    <dl class="sip-view-dl sip-view-summary__meta">
        <div class="sip-view-dl__row">
            <dt>{{trans('user.date_of_birth')}}</dt>
            <dd>{{user.profile.date_of_birth | moment}}</dd>
        </div>
        <div class="sip-view-dl__row">
            <dt>{{trans('user.date_of_anniversary')}}</dt>
            <dd>{{user.profile.date_of_anniversary | moment}}</dd>
        </div>
        <div class="sip-view-dl__row">
            <dt>{{trans('user.created_at')}}</dt>
            <dd>{{user.created_at | moment}}</dd>
        </div>
        <div class="sip-view-dl__row">
            <dt>{{trans('user.phone')}}</dt>
            <dd>{{user.profile.phone || '—'}}</dd>
        </div>
    </dl>
</div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        props: {
            user: {
                default: {
                    profile: {}
                },
                required: true
            }
        },
        methods: {
            getUserStatus(user){
                return helper.getUserStatus(user);
            },
            updateStatus(status){
                axios.post('/api/user/'+this.user.id+'/status',{
                    status: status
                })
                .then(response => response.data)
                .then(response => {
                    this.user.status = status;
                    toastr.success(response.message);
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
            },
            getAuthUser(name){
                return helper.getAuthUser(name);
            },
            getAvatar(user){
                return  helper.getAvatar(user);
            }
        },
        mounted(){
        },
        computed: {
            hasSocial() {
                const profile = this.user && this.user.profile ? this.user.profile : {};
                return !!(profile.facebook_profile || profile.twitter_profile || profile.linkedin_profile || profile.google_plus_profile);
            }
        },
        watch: {
            user(newVal){
                this.user = newVal;
            }
        },
        filters: {
          moment(date) {
            return helper.formatDate(date);
          }
        }
    }
</script>
